<form class="map-picker">
  <label class="picker">
    Category
    <select class="select" [(ngModel)]="category" name="category" id="category">
      <option *ngFor="let category of categories" [ngValue]="category">{{ category }}</option>
    </select>
  </label>
  <label class="picker">
    Map Template
    <select class="select" [(ngModel)]="map" name="map" id="map" [disabled]="!category">
      <option *ngFor="let map of filteredMaps" [ngValue]="map">{{ map.name }}</option>
    </select>
  </label>
</form>
<div *ngIf="map?.description" class="map-description">
  <label>
    Description
    <p>{{ map.description }}</p>
  </label>
</div>